var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './styles.css';
var Button = function (props) {
    var _a;
    return (_jsx("button", __assign({ type: props.type, onClick: props.onClick, className: "buttonComponent " + (props.lineBtn ? 'lineBtn' : '') + " " + ((_a = props.className) !== null && _a !== void 0 ? _a : '') + " " + (props.isButtonDisabled ? 'desabilit-button' : '') }, { children: props.children }), void 0));
};
export default Button;
